// Shared constants for schema.org JSON-LD structured data.

// schema.org Rating bounds, emitted as strings across the product/review JSON-LD.
export const BEST_RATING = '5';
export const WORST_RATING = '1';

// Author fallback for brand-page reviews. Must match the label SingleReview renders on screen so the
// JSON-LD reflects visible content (distinct from DEFAULT_REVIEWER_NAME in appConstants, used on PDP).
export const DEFAULT_BRAND_REVIEWER_NAME = 'Zappos Reviewer';
